import {auth} from "../firebase";

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8090';

async function getIdTokenOrThrow() {
    const u = auth.currentUser;
    if (!u) throw new Error("Not authenticated (Firebase user missing)");
    return await u.getIdToken();
}

export async function apiFetch(path, options = {}) {
    const {
        auth: useAuth = true,
        headers,
        ...rest
    } = options;

    const token = useAuth ? await getIdTokenOrThrow() : null;
    const res = await fetch(`${API_BASE}${path}`, {
        ...rest,
        headers: {
            ...(headers || {}),
            ...(token ? {Authorization: `Bearer ${token}`} : {}),
        },
    });

    if (!res.ok) {
        const text = await res.text().catch(() => "");
        const err = new Error(text || `HTTP ${res.status}`);
        err.status = res.status;
        err.body = text;
        throw err;
    }
    return res;
}

export { API_BASE };